const startHooks = [];
const endHooks = [];

const addStartHook = (fn) => {
  const idx = startHooks.indexOf(fn);
  if (idx === -1) {
    startHooks.push(fn);
  }
}
const addEndHook = (fn) => {
  const idx = endHooks.indexOf(fn);
  if (idx === -1) {
    endHooks.push(fn);
  }
}
const removeStartHook = (fn) => {
  const idx = startHooks.indexOf(fn);
  if (idx !== -1) {
    startHooks.splice(idx, 1);
  }
}
const removeEndHook = (fn) => {
  const idx = endHooks.indexOf(fn);
  if (idx !== -1) {
    endHooks.splice(idx, 1);
  }
}
const startAuthSession = () => {
  startHooks.map(fn => fn());
}
const endAuthSession = () => {
  endHooks.map(fn => fn());
}

export { addStartHook, addEndHook, removeStartHook, removeEndHook, startAuthSession, endAuthSession }
